module.exports = __webpack_public_path__ + "img/topic_bg_bps.423bd2a8.svg";